import { PerformedByRequestDTO } from './performed-by-request-dto';
import { UserContextRoleScopeProfileIdDTO } from './user-context-role-scope-profile-id-dto';

export interface SaveUserContextRoleScopeProfileRequestDTO extends PerformedByRequestDTO {
    userId?: number;
    userEmail?: string;
    userContextRoleId?: number;
    languageCd?: string;
    profileStatus?: string;
    deniedReason?: string;
    isInternal?: boolean;
    scopes?: UserContextRoleScopeProfileIdDTO[];
}
